export default __webpack_public_path__ + "static/fall22-300d0f85ca06b7f11f16d6a344caaa8d.webp";